import PropTypes from 'prop-types'
import React from 'react'
import { useQuery } from '@apollo/client'
import { PAGE_CONTEXT as p } from 'Constants'
import { GET_CONTENTS } from 'Queries'
import { ErrorView, CardLoadingGrid } from 'Blocks'
import Component from './component'
import config from 'Config'
// import testContents from '../../testContents'
const ProductListContainer = props => {
  const categoryUuid = props.match.params.uuid
  const variables = {
    arguments: {
      type: 'article',
      categoryUuid,
      state: 'PUBLISHED'
    },
    pagination: {
      size: config.pagination.productListArticles,
      page: 1
    }
  }

  const { articlesEnabled, articlesOnProductListPage } = config

  const { loading, error, data } = useQuery(GET_CONTENTS, {
    variables,
    fetchPolicy: 'no-cache'
  })

  if (!articlesEnabled || !articlesOnProductListPage)
    return <Component {...props} articles={[]} />

  if (loading) return <CardLoadingGrid pageName={p.PRODUCT_LIST} />

  if (error) return <ErrorView message={error.message} error={error} />

  // data = testContents
  return <Component {...props} articles={data.contents.contents} />
}

ProductListContainer.propTypes = {
  match: PropTypes.object
}

export default ProductListContainer
